export default "__VITE_ASSET__6f9040d7__"